export function translateAuthError(code, message) {
  switch (code) {
    case 'invalid_credentials':
      return 'Email ou mot de passe incorrect.';
    case 'email_not_confirmed':
      return 'Merci de confirmer votre email avant de vous connecter.';
    case 'too_many_requests':
    case 'over_email_send_rate_limit':
      return 'Trop de tentatives. Réessayez dans quelques minutes.';
    case 'captcha_invalid':
      return 'Vérification anti-robot invalide. Réessayez.';
    case 'same_password':
      return 'Le nouveau mot de passe doit être différent de l\'ancien.';
    case 'weak_password':
      return 'Mot de passe trop faible. Choisissez un mot de passe plus robuste.';
    case 'session_not_found':
    case 'session_expired':
      return 'Votre session a expiré. Demandez un nouveau lien de réinitialisation.';
    default:
      return message || 'Une erreur est survenue. Veuillez réessayer.';
  }
}
